import { BetTypeEnum, BetTypeViewEnum } from "src/constants/enums/betType";
import { ISelection } from "src/constants/interfaces/bet";
import { IClientConfig } from "src/client-config/config";
import { racingTypesList } from "src/constants/racingTypesList";
import { getEffectiveSelectionsCount } from "./betBuilder";

export const MarketTypes = {
	WINNER: 1,
	FORECAST: 2,
	TRICAST: 3,
};

export const findProperBetType = (config: IClientConfig, selections: ISelection[]) => {
	const isRacingBet = selections.some(item => item.event.marketType && item.event.marketType !== 1);

	if (isRacingBet) {
		let betType;
		const marketType = selections[0].event.marketType;

		switch (marketType) {
			case MarketTypes.FORECAST:
				if (selections[0].event.eventOption === 3)
					betType =
						selections.length === 2
							? BetTypeEnum.ReverseForecast
							: BetTypeEnum.CombinationForecast;
				else betType = BetTypeEnum.StraightForecast;
				break;
			case MarketTypes.TRICAST:
				if (selections[0].event.eventOption === 4) betType = BetTypeEnum.CombinationTricast;
				else betType = BetTypeEnum.StraightTricast;
				break;
		}

		return betType;
	} else {
		// Use effective count so a single bet builder card (with N events) counts as 1.
		const count = getEffectiveSelectionsCount(selections);

		const [betType] =
			Object.entries(config.availableBetTypes).find(([betType, item]) => {
				const rightBetType =
					count >= (item?.minSelectionsCount || Number.MIN_SAFE_INTEGER) &&
					count <= (item?.maxSelectionsCount || Number.MAX_SAFE_INTEGER);

				return rightBetType;
			}) || [];

		return betType && BetTypeEnum[betType as keyof typeof BetTypeEnum];
	}
};

export const betTypeFitsConfig = (config: IClientConfig, selections: ISelection[], betType: BetTypeEnum) => {
	const betTypeData = config.availableBetTypes[BetTypeViewEnum[betType]];

	if (!betTypeData) return false;

	const count = getEffectiveSelectionsCount(selections);

	const rightBetType =
		count >= (betTypeData?.minSelectionsCount || Number.MIN_SAFE_INTEGER) &&
		count <= (betTypeData?.maxSelectionsCount || Number.MAX_SAFE_INTEGER);

	return rightBetType;
};
